import { Injectable, NgZone, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertComponent } from '../shared/alert/alert.component';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {

  private idleTime: number = 0;
  private idleAuthTime: number = 0;
  private idleLimit: number = 300 * 12; // Timeout after 5 minutes (300 seconds)
  private idleAuthLimit: number = 300 * 3; // Timeout after 5 minutes (300 seconds)
  private warningTime: number = 60; // Show warning 1 minute before timeout
  public showWarning: boolean = false;
  public countdown: number = this.warningTime; // Countdown for warning
  private interval: any;
  private countdownInterval: any;
  @ViewChild("alertContent", { static: true }) _alertModal!: AlertComponent;
  constructor(private router: Router, private ngZone: NgZone, private auth: AuthService) {
    this.startWatching();
    this.resetIdleTimer();
  }

  setLimit(number: number) {
    this.idleLimit = number * 60;
  }

  startWatching() {
    // Listen to user activity
    console.log('Starting Timer')
    window.addEventListener('mousemove', () => this.resetIdleTimer());
    window.addEventListener('keypress', () => this.resetIdleTimer());
    window.addEventListener('click', () => this.resetIdleTimer());
  }

  resetIdleTimer() {
    this.idleTime = 0;
    this.showWarning = false;
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    if (this._alertModal) {
      if (this._alertModal.isOpen) {
        this._alertModal.close()
      }

    }

    this.startIdleTimer();
  }

  startIdleTimer() {
    // Start a timer to increment idle time
    this.ngZone.runOutsideAngular(() => {
      this.interval = setInterval(() => {
        this.idleTime++;
       // console.log(this.idleTime)
        this.idleAuthTime++;
        if (this.idleAuthTime > this.idleAuthLimit && this.auth.IsAuthorizedUser()) {
          this.idleAuthTime = 1;
          this.auth.refreshToken();
        }
        if (this.idleTime >= this.idleLimit - this.warningTime && !this.showWarning) {
          this.ngZone.run(() => {
            this.showIdleWarning();
          });
        }
        if (this.idleTime >= this.idleLimit) {
          this.ngZone.run(() => {
            this.logout();
          });
        }

      }, 1000); // Check every second
    });
  }

  showIdleWarning() {
    this.showWarning = true;
    this.countdown = this.warningTime;
    this.startCountdown();
    this.onTimeOutWarning();
  }

  startCountdown() {
    this.ngZone.runOutsideAngular(() => {
      this.countdownInterval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownInterval);
        }
        this.updateWarningMessage();
      }, 1000); // Countdown every second
    });
  }

  setAlert(alertModal: AlertComponent) {
    this._alertModal = alertModal;
  }
  public onTimeOutWarning() {
    console.log("On time Out Warning Started");
    this._initializeAlertModal();
    this._alertModal.message = `No activity detected. You will be logged out in ${this.countdown} seconds.`;
    this._alertModal.alertFooter = true;
    this._alertModal.cancelButton = false;
    this._alertModal.okButton = false;
    this._alertModal.okButtonText = "Extend";

    if (!this._alertModal.isOpen) {
      this._alertModal.open(this._alertModal.ngTemplate);
    }
  }
  private _initializeAlertModal() {
    this._alertModal.alertFooter = false;
    this._alertModal.cancelButton = false;
    this._alertModal.okButton = false;
    this._alertModal.okButtonText = "Session ";
    this._alertModal.alertHeader = true;
    this._alertModal.alertTitle = "Attention!";
    this._alertModal.message = "";
  }

  logout() {
    this._alertModal.close();
    clearInterval(this.interval);
    clearInterval(this.countdownInterval);
    this.auth.LogOut();
  }

  updateWarningMessage() {
    if (this._alertModal.isOpen) {
      this.ngZone.run(() => {
        this._alertModal.message = `No activity detected. You will be logged out in ${this.countdown} seconds.`;
      })
    }
  }
}
